import { render, staticRenderFns } from "./well.vue?vue&type=template&id=471f746e&"
import script from "./well.vue?vue&type=script&lang=ts&"
export * from "./well.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports